var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.44283C18.3333 6.93798 18.3333 6.68556 18.2335 6.56867C18.1469 6.46725 18.0169 6.41343 17.884 6.42389C17.7307 6.43595 17.5522 6.61444 17.1953 6.97142L14.1667 10L17.1953 13.0286C17.5522 13.3856 17.7307 13.5641 17.884 13.5761C18.0169 13.5866 18.1469 13.5328 18.2335 13.4314C18.3333 13.3145 18.3333 13.0621 18.3333 12.5572V7.44283Z",
    stroke: "#155B75",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 8.16669C1.66667 6.76656 1.66667 6.06649 1.93916 5.53171C2.17884 5.06131 2.56129 4.67885 3.0317 4.43917C3.56647 4.16669 4.26654 4.16669 5.66667 4.16669H10.1667C11.5668 4.16669 12.2669 4.16669 12.8016 4.43917C13.2721 4.67885 13.6545 5.06131 13.8942 5.53171C14.1667 6.06649 14.1667 6.76656 14.1667 8.16669V11.8334C14.1667 13.2335 14.1667 13.9336 13.8942 14.4683C13.6545 14.9387 13.2721 15.3212 12.8016 15.5609C12.2669 15.8334 11.5668 15.8334 10.1667 15.8334H5.66667C4.26654 15.8334 3.56647 15.8334 3.0317 15.5609C2.56129 15.3212 2.17884 14.9387 1.93916 14.4683C1.66667 13.9336 1.66667 13.2335 1.66667 11.8334V8.16669Z",
    stroke: "#155B75",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b3b7cf5afa3194eb5ca5516d88b96852.svg";
export { ForwardRef as ReactComponent };